// extracted by mini-css-extract-plugin
module.exports = {"content":"roomScreen_content__2Pzqq","footer":"roomScreen_footer__2jmbS"};